/*
 * @Date: 2022-08-15 14:48:10
 * @LastEditTime: 2022-10-06 15:46:55
 * @Description:
 */
import { net_common } from "@/api/http";
export const API_DisplayBopAccountManageScreen = (...params) =>
  net_common.post("/api/STDSDC02C08/DisplayBopAccountManageScreen", ...params);

export const API_UpdateBopAccount = (...params) =>
  net_common.post("/api/STDSDC02C08/UpdateBopAccount", ...params);

export const API_SendMailToAccountNotification = (...params) =>
  net_common.post("/api/STDSDC02C08/SendMailToAccountNotification", ...params);
